// @ts-ignore
import {Unity, IUnityContextHook} from 'react-unity-webgl'

export const HangarUnity = ({ visible, provider }: { visible: boolean, provider: IUnityContextHook}) => {
  return <Unity matchWebGLToCanvasSize={true} unityProvider={provider}
         style={{width: "100%", height: "100%", visibility: visible ? "visible" : "hidden"}}/>
}